/**
 * EliorGroup.Time.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AvailabilityStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const AvailabilityStatus = {
    NUMBER_0: 0 as AvailabilityStatus,
    NUMBER_1: 1 as AvailabilityStatus,
    NUMBER_2: 2 as AvailabilityStatus,
    NUMBER_3: 3 as AvailabilityStatus,
    NUMBER_4: 4 as AvailabilityStatus,
    NUMBER_5: 5 as AvailabilityStatus,
    NUMBER_6: 6 as AvailabilityStatus
};

